import React, { Component } from 'react';

/**
 * Pill beside the launcher: a line of text and an optional response-time line. The parent
 * decides when it exists (launcher-engagement.js); this draws it and reports clicks.
 */
export default class LauncherLabel extends Component {
    constructor(props) {
        super(props);
        this.state = { mounted: false };
    }

    componentDidMount() {
        this._raf = requestAnimationFrame(() => this.setState({ mounted: true }));
    }

    componentWillUnmount() {
        if (this._raf) cancelAnimationFrame(this._raf);
    }

    handleClose = (e) => {
        e.stopPropagation();
        if (this.props.onClose) this.props.onClose();
    }

    render() {
        const { primary, secondary, launcherSize, isMobile, closing, closeLabel, onClick, reducedMotion } = this.props;
        const visible = this.state.mounted && !closing;
        const size = Number(launcherSize) || 56;

        return (
            <div
                data-lc-launcher-label="1"
                style={{
                    position: 'absolute',
                    right: size + 12,
                    bottom: size / 2,
                    maxWidth: isMobile ? `calc(100vw - ${size + 56}px)` : 280,
                    width: 'max-content',
                    pointerEvents: 'auto',
                    transform: `translateY(50%) translateX(${visible ? 0 : 8}px)`,
                    opacity: visible ? 1 : 0,
                    transition: reducedMotion ? 'none' : 'transform var(--lc-dur-base) var(--lc-ease-out), opacity var(--lc-dur-base) var(--lc-ease-out)',
                }}
            >
                <div
                    role="button"
                    tabIndex={0}
                    aria-label={secondary ? `${primary}. ${secondary}` : primary}
                    onClick={onClick}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(e); } }}
                    style={{
                        background: 'var(--lc-surface, #fff)',
                        color: 'var(--lc-text, #1e293b)',
                        border: 'var(--lc-hairline)',
                        borderRadius: 'var(--lc-radius-full)',
                        boxShadow: 'var(--lc-shadow-3)',
                        padding: '10px 34px 10px 16px',
                        cursor: 'pointer',
                        lineHeight: 1.35,
                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                    }}
                >
                    <div style={{ fontSize: 14, fontWeight: 600, overflowWrap: 'anywhere' }}>{primary}</div>
                    {secondary && (
                        <div style={{ fontSize: 12, color: 'var(--lc-text-2, #64748b)', marginTop: 1, overflowWrap: 'anywhere' }}>{secondary}</div>
                    )}
                </div>
                <button
                    type="button"
                    aria-label={closeLabel}
                    onClick={this.handleClose}
                    style={{
                        position: 'absolute',
                        top: '50%',
                        right: 8,
                        transform: 'translateY(-50%)',
                        width: 22,
                        height: 22,
                        padding: 0,
                        border: 'none',
                        borderRadius: 'var(--lc-radius-full)',
                        background: 'transparent',
                        color: 'var(--lc-text-3, #94a3b8)',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                        <path d="M18 6L6 18M6 6l12 12" />
                    </svg>
                </button>
            </div>
        );
    }
}
